export const FORGE_MASTER_LABEL_PATH = '/forge/labeling-tools/master-label';
export const FORGE_REMOTE_DC_TOOL_PATH = '/forge/labeling-tools/remote-dc';
export const FORGE_DESIGNS_DASHBOARD_PATH = '/forge/dashboards/designs';
export const FORGE_DESIGN_GROUPS_DASHBOARD_PATH = '/forge/dashboards/design-groups';
export const FORGE_PR_INFERENCE_OKRS_PATH = '/forge/dashboards/pr-inference-okrs';
export const FORGE_SYSTEM_HEALTH_PATH = '/forge/dashboards/system-health';
export const FORGE_STORE_DC_TASK_LIST_PATH = '/forge/task-lists/store-dc';
export const FORGE_REMOTE_DC_TASK_LIST_PATH = '/forge/task-lists/remote-dc';
export const FORGE_UNRESOLVED_TASK_LIST_PATH = '/forge/task-lists/unresolved';
export const FORGE_REMOTE_DC_CONFIG_PATH = '/forge/configuration/remote-dc';
